import React from "react";
import { Question } from "@phosphor-icons/react";

/**
 * HelpAnchor — Kompakter Frage-Icon-Link, der die ET-Dokumentation in
 * einem neuen Tab am passenden Anker öffnet.
 *
 * Iter 19.63.108 — User-Wunsch: pro Workflow-Schritt einen ?-Icon, der
 * den User direkt zur relevanten Doku-Sektion bringt, ohne den aktuellen
 * Tool-Stand zu verlassen.
 *
 * Props:
 *   • anchor  — Hash-Anker in /hilfe (z. B. "schritt-1", "math-bypass")
 *   • label   — Optional: Tooltip-Text. Default: "Hilfe zu diesem Schritt"
 *   • testId  — Optional: data-testid (Default abgeleitet aus anchor)
 *
 * Beispiel:
 *   <HelpAnchor anchor="schritt-3" label="Wie funktioniert dieser Schritt?" />
 */
export default function HelpAnchor({
  anchor,
  label = "Hilfe zu diesem Schritt",
  testId,
  className = "",
}) {
  const href = anchor ? `/hilfe#${anchor}` : "/hilfe";
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={label}
      aria-label={label}
      data-testid={testId || `help-anchor-${anchor || "general"}`}
      className={[
        "inline-flex items-center justify-center w-6 h-6 rounded-full",
        "border border-ink-200 bg-white text-warm-600",
        "transition-crisp hover:bg-brand-50 hover:border-brand-300 hover:text-brand-600",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 focus-visible:ring-offset-1",
        className,
      ].join(" ")}
    >
      <Question size={13} weight="bold" />
    </a>
  );
}
